import type {
  CreateEgressProfileRequest,
  CreateEgressProfileResponse,
  DeleteEgressProfileResponse,
  EgressProfileRecord,
  ListEgressProfilesResponse,
  UpdateEgressProfileRequest,
  UpdateEgressProfileResponse,
} from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

const BASE_PATH = '/v1/ops/egress-profiles';

export async function listEgressProfiles(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<EgressProfileRecord[]> {
  const response = await opsApiRequest<ListEgressProfilesResponse>(
    BASE_PATH,
    { signal },
    fetchImpl,
  );
  return [...response.egress_profiles];
}

export async function createEgressProfile(
  body: CreateEgressProfileRequest,
  fetchImpl: typeof fetch,
): Promise<EgressProfileRecord> {
  const response = await opsApiRequest<CreateEgressProfileResponse>(
    BASE_PATH,
    { method: 'POST', body },
    fetchImpl,
  );
  return response.egress_profile;
}

export async function updateEgressProfile(
  profileId: string,
  body: UpdateEgressProfileRequest,
  fetchImpl: typeof fetch,
): Promise<EgressProfileRecord> {
  const response = await opsApiRequest<UpdateEgressProfileResponse>(
    `${BASE_PATH}/${encodeURIComponent(profileId)}`,
    { method: 'PATCH', body },
    fetchImpl,
  );
  return response.egress_profile;
}

export async function deleteEgressProfile(
  profileId: string,
  fetchImpl: typeof fetch,
): Promise<DeleteEgressProfileResponse> {
  return opsApiRequest<DeleteEgressProfileResponse>(
    `${BASE_PATH}/${encodeURIComponent(profileId)}`,
    { method: 'DELETE' },
    fetchImpl,
  );
}
